import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { LocalStorageService, SessionStorageService } from 'ng2-webstorage';
import { Credentials, ExternalAuthenticationData } from '../../models';
import { Converter } from '../';

@Injectable()
export class AuthenticationJwtService {
    private static TOKEN_STORAGE_KEY = 'authenticationToken';

    constructor(private http: Http,
                private $localStorage: LocalStorageService,
                private $sessionStorage: SessionStorageService) {
    }

    private authenticateSuccess(response: Response, rememberMe: boolean) {
        const bearerToken = response.headers.get('Authorization');
        if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
            const jwt = bearerToken.slice(7, bearerToken.length);
            this.storeAuthenticationToken(jwt, rememberMe);
            return jwt;
        }
    }

    private getToken(): any {
        return this.$localStorage.retrieve(AuthenticationJwtService.TOKEN_STORAGE_KEY) ||
            this.$sessionStorage.retrieve(AuthenticationJwtService.TOKEN_STORAGE_KEY);
    }

    public login(credentials: Credentials): Observable<any> {
        const data = Converter.toJson(credentials);
        return this.http.post('api/authenticate', data).map((response: Response) => {
            return this.authenticateSuccess(response, credentials.rememberMe);
        });
    }

    public loginWithToken(jwt: any, rememberMe: boolean) {
        if (jwt) {
            this.storeAuthenticationToken(jwt, rememberMe);
            return Promise.resolve(jwt);
        } else {
            return Promise.reject('Invalid JWT provided.');
        }
    }

    public loginExternal(externalAuthenticationData: ExternalAuthenticationData): Observable<any> {
        const data = Converter.toJson(externalAuthenticationData);
        return this.http.post('api/authenticate/external', data).map((response: Response) => {
            return this.authenticateSuccess(response, false);
        });
    }

    private storeAuthenticationToken(jwt: any, rememberMe: boolean) {
        if (rememberMe && rememberMe === true) {
            this.$localStorage.store(AuthenticationJwtService.TOKEN_STORAGE_KEY, jwt);
        } else {
            this.$sessionStorage.store(AuthenticationJwtService.TOKEN_STORAGE_KEY, jwt);
        }
    }

    public logout(): Observable<any> {
        return new Observable((observer) => {
            this.$localStorage.clear(AuthenticationJwtService.TOKEN_STORAGE_KEY);
            this.$sessionStorage.clear(AuthenticationJwtService.TOKEN_STORAGE_KEY);
            observer.complete();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/auth/authentication-jwt.service.ts